<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { getColor } from '$lib/helper';
    import { personalizeHtml } from '$lib/personalizeHtml';

    import ListView from './List.View.svelte';

    import type { ListContent } from '$lib/types/Components/List/ListContent';
    import type { ListItemProps } from '$lib/types/Components/List/ListItemProps';
    import type { Component } from '$lib/types/Components/SharedTypes';
    import type { Language } from '$lib/types/Language';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    export let id = '';
    export let childComponents: Component[] = [];
    export let content: ListContent;
    export let theme: Theme;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let campaignId = '';
    export let trackingProperties: TrackingProperty[] = [];
    export let language: Language = 'en';
    export let layout = DEFAULT_LAYOUT;

    const listItems: ListItemProps[] = childComponents
        .filter((listItem) => {
            // TODO CF: fix it on editor side instead of filtering it here
            return listItem.components[0] && listItem.components[1];
        })
        .map((listItem) => {
            const media = listItem.components[0];
            const text = listItem.components[1];

            return {
                id: listItem._id,
                align: content.align,
                color: getColor(text.content.color, theme.fontColor),
                iconColor: getColor(media.content.color, theme.buttonBackgroundColor),
                wysiwygHtml: personalizeHtml(text.content.wysiwygHtml, {
                    trackingProperties,
                    campaignId,
                    language,
                }),
                emoji: media.content.emoji,
                imageSrc: media.content.src,
                mediaType: media.content.srcType,
                cornerRounding: content.borderRadius,
                linkColor: theme.buttonBackgroundColor,
                svg: media.content.svg,
                iconName: media.content.iconName,
                platform: media.content.platform,
                isAnimated: media.content.isAnimated,
                jsonUrl: media.content.jsonUrl,
                mediaIds: media.content.mediaIds,
            } satisfies ListItemProps;
        });
</script>

<ListView
    {id}
    box={content.box}
    align={content.align}
    textSize={content.textSize}
    visualSize={content.visualSize}
    {listItems}
    {transitionDelay}
    {transitionEffect}
    {layout}
/>
